import React, { useState, useEffect, useCallback } from "react";
import { api } from '../../services/api.js';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer";
import { useNavigate } from "react-router-dom";
import { FaClock } from 'react-icons/fa';
import './index.css';

import img1 from './../../../public/Images/1.png';
import img2 from './../../../public/Images/2.png';
import img3 from './../../../public/Images/3.png';
import img4 from './../../../public/Images/4.png';
import img5 from './../../../public/Images/5.png';

const sentimentosMap = {
    1: img1,
    2: img2,
    3: img3,
    4: img4,
    5: img5,
};

function Ponto() {
    const [nome, setNome] = useState('');
    const [Deschor, setDeschor] = useState('');
    const [saldo, setSaldo] = useState('');
    const [horaFim, setHoraFim] = useState('');
    const [extraBanco, setExtraBanco] = useState('');
    const [atrasoBanco, setAtrasoBanco] = useState('');
    const [faltaBanco, setFaltaBanco] = useState('');
    const [bancoHora, setBancoHora] = useState('');
    const [tabelas, setTabela] = useState([]);

    const hoje = new Date();
    const mesAtual = String(hoje.getMonth() + 1).padStart(2, '0');
    const anoAtual = hoje.getFullYear();
    const [mesano, setMesAno] = useState(mesAtual + String(anoAtual));
    const chapa = localStorage.getItem("chapa");
    const navigate = useNavigate();

    useEffect(() => {
        if (!chapa) {
            navigate("/arbor/login");
        }
    }, [chapa, navigate]);

    const Buscarponto = useCallback(() => {
        api.get('/ponto/' + chapa + '/lista?data=' + mesano)
            .then((retorno) => {
                if (retorno.data && retorno.data[0]) {
                    setDeschor(retorno.data[0].descricao);
                    setTabela(retorno.data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, [chapa, mesano]);

    useEffect(() => {
        if (!mesano || !chapa) return;

        setTabela([]);
        api.get('/ponto/' + chapa + '/total?data=' + mesano)
            .then((retorno) => {
                if (retorno.data && retorno.data[0]) {
                    setSaldo(retorno.data[0].saldo);
                    setHoraFim(retorno.data[0].horafinal);
                    setNome(retorno.data[0].nome);
                    setExtraBanco(retorno.data[0].extra_banco);
                    setAtrasoBanco(retorno.data[0].atraso_banco);
                    setFaltaBanco(retorno.data[0].falta_banco);
                    setBancoHora(retorno.data[0].bancohora);
                    Buscarponto();
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, [mesano, chapa, Buscarponto]);

    function handleMesAno(dmesano) {
        if (!dmesano) return;
        setMesAno(dmesano);
    }

    // Helper para retornar a imagem correspondente ao ID do sentimento
    const getSentimentoImg = (id) => {
        if (!id) return null;
        return sentimentosMap[id] || null;
    };

    return (
        <div className="bg-light min-vh-100" style={{ paddingTop: '80px', paddingBottom: '40px' }}>
            <Menu modulo="ARBOR" />

            <div
                className="container-fluid py-3 px-3 px-md-5"
                style={{ maxWidth: '1280px', margin: '0 auto' }}
            >
                {/* Título e Filtro de Mês */}
                <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2">
                    <div>
                        <h4 className="fw-bold m-0 d-flex align-items-center text-dark">
                            <FaClock className="me-2 text-danger" />
                            Espelho de Ponto
                        </h4>
                        <small className="text-muted">Acompanhe suas marcações diárias e banco de horas</small>
                    </div>

                    <div className="bg-white p-2 rounded-3 border shadow-sm">
                        <input
                            type="month"
                            id="month"
                            className="form-control border-0 fw-bold text-danger-gradient"
                            onChange={(e) => handleMesAno(e.target.value.substring(5, 7) + e.target.value.substring(0, 4))}
                            value={`${mesano.substring(2, 6)}-${mesano.substring(0, 2)}`}
                        />
                    </div>
                </div>

                {/* Card de Resumo do Funcionário */}
                <div className="card border-0 shadow-sm rounded-4 overflow-hidden mb-4 bg-white">
                    <div className="card-header border-0 text-white p-3 p-md-4" style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)' }}>
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <div>
                                <h5 className="fw-bold m-0 text-white">{nome || 'Funcionário'}</h5>
                                <small className="text-white-50">Horário: {Deschor || 'Não especificado'}</small>
                            </div>
                            <div className="text-md-end">
                                <span className="small text-white-50 d-block">Saldo do Período</span>
                                <strong className="fs-5 text-white">{saldo || '00:00'}</strong>
                            </div>
                        </div>
                    </div>

                    <div className="card-body p-3 bg-light">
                        <div className="row text-center g-2">
                            <div className="col-4 col-md-2.4">
                                <div className="p-2 bg-white rounded-3 border">
                                    <small className="text-muted d-block extra-small">Extra</small>
                                    <span className="fw-bold text-success">{extraBanco || '00:00'}</span>
                                </div>
                            </div>
                            <div className="col-4 col-md-2.4">
                                <div className="p-2 bg-white rounded-3 border">
                                    <small className="text-muted d-block extra-small">Atraso</small>
                                    <span className="fw-bold text-warning">{atrasoBanco || '00:00'}</span>
                                </div>
                            </div>
                            <div className="col-4 col-md-2.4">
                                <div className="p-2 bg-white rounded-3 border">
                                    <small className="text-muted d-block extra-small">Falta</small>
                                    <span className="fw-bold text-danger">{faltaBanco || '00:00'}</span>
                                </div>
                            </div>
                            <div className="col-6 col-md-2.4">
                                <div className="p-2 bg-white rounded-3 border">
                                    <small className="text-muted d-block extra-small">Banco</small>
                                    <span className="fw-bold text-dark">{bancoHora || '00:00'}</span>
                                </div>
                            </div>
                            <div className="col-6 col-md-2.4">
                                <div className="p-2 bg-white rounded-3 border">
                                    <small className="text-muted d-block extra-small">Final</small>
                                    <span className="fw-bold text-primary">{horaFim || '00:00'}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Lista de Marcações Diárias */}
                <div className="card border-0 shadow-sm rounded-4 overflow-hidden bg-white">
                    <div className="card-body p-0">
                        {/* 🖥️ Visão Desktop */}
                        <div className="d-none d-md-block">
                            <table className="table table-hover align-middle m-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-center py-3">Dia</th>
                                        <th className="text-start py-3">Marcações Realizadas</th>
                                        <th className="text-center py-3">Trabalhado</th>
                                        <th className="text-center py-3">Ocorrência</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tabelas.map((tabela) => {
                                        const idSentimento = tabela.sentimento || tabela.idsentimento || tabela.id_sentimento;
                                        const imgSentimento = getSentimentoImg(idSentimento);

                                        return (
                                            <tr key={tabela.data}>
                                                <div className="d-flex align-items-center gap-2">
                                                    <div style={{ width: '20px', height: '20px' }} className="d-flex align-items-center justify-content-center">
                                                        {imgSentimento ? (
                                                            <img
                                                                src={imgSentimento}
                                                                alt="Sentimento do dia"
                                                                style={{ width: '20px', height: '20px', objectFit: 'contain' }}
                                                            />
                                                        ) : null}
                                                    </div>
                                                    <span className="fw-bold text-dark fs-6">{tabela.data}</span>
                                                    
                                                </div>
                                                <td className="text-start text-secondary fw-semibold">{tabela.marcacoes || '--:--'}</td>
                                                <td className="text-center text-muted">{tabela.trabalhado || '00:00'}</td>
                                                <td className="text-center">
                                                    {tabela.ocorrencia ? (
                                                        <span
                                                            className="badge bg-danger text-white fw-bold px-2 py-1 fs-6"
                                                            style={{ color: '#ffffff !important' }}
                                                        >
                                                            {tabela.ocorrencia}
                                                        </span>
                                                    ) : (
                                                        <span className="text-muted small"></span>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        {/* 📱 Visão Mobile */}
                        <div className="d-md-none p-2">
                            {tabelas.map((tabela) => {
                                const idSentimento = tabela.sentimento || tabela.idsentimento || tabela.id_sentimento;
                                const imgSentimento = getSentimentoImg(idSentimento);

                                return (
                                    <div key={tabela.data} className="p-3 mb-2 rounded-3 border bg-light">
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <div className="d-flex align-items-center gap-2">
                                                <span className="fw-bold text-dark fs-6">Dia {tabela.data}</span>
                                                {imgSentimento && (
                                                    <img
                                                        src={imgSentimento}
                                                        alt="Sentimento do dia"
                                                        style={{ width: '20px', height: '20px', objectFit: 'contain' }}
                                                    />
                                                )}
                                            </div>

                                            {tabela.ocorrencia && (
                                                <span
                                                    className="badge bg-danger text-white fw-bold extra-small"
                                                    style={{ color: '#ffffff !important' }}
                                                >
                                                    {tabela.ocorrencia}
                                                </span>
                                            )}
                                        </div>
                                        <div className="text-secondary fw-semibold small mb-2">
                                            ⏱️ Marcações: <span className="text-dark">{tabela.marcacoes || '--:--'}</span>
                                        </div>
                                        <div className="pt-2 border-top d-flex justify-content-between align-items-center extra-small text-muted">
                                            <span>Trabalhado: <strong>{tabela.trabalhado || '00:00'}</strong></span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default Ponto;